import { AppNexusData } from '../../shared/types/ast';

export function setupFinnGlobalVar(appNexusData: AppNexusData) {
    window.FINN = window.FINN || {};
    window.FINN.banner = window.FINN.banner || {};
    window.FINN.banner.feed = appNexusData.feed;
    window.FINN.banner.feedString = appNexusData.feedString;
    window.FINN.banner.ssa = appNexusData.ssa;
    window.FINN.banner.ads = {};
    window.FINN.banner.override = '';
}

export function updateFinnGlobalVar(creativeIds: { [key: string]: number }) {
    const overrideString = Object.keys(creativeIds).reduce(
        (result, key) => `${key}:${creativeIds[key]},${result}`,
        '',
    );

    window.FINN = window.FINN || {};
    window.FINN.banner = window.FINN.banner || {};
    window.FINN.banner.ads = creativeIds;
    window.FINN.banner.override = `ast_override_div=${overrideString}`;
}
